import type { AxiosInstance } from 'axios'
import axios from 'axios'
import { useAuth } from './useAuth'

const http: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
})

export const defineInterceptors = () => {
  http.interceptors.request.use(
    async (config) => {
      const { getToken } = useAuth()
      const token = await getToken()

      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }

      return config
    },
    (error) => {
      return Promise.reject(error)
    },
  )

  http.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config

      if (error.response?.status === 401) {
        if (originalRequest._retry) {
          const { login } = useAuth()

          await login(true)

          return Promise.reject(error)
        }

        // Mark as retried and retry the request with a refreshed token
        originalRequest._retry = true

        return http(originalRequest)
      }

      return Promise.reject(error)
    },
  )
}
defineInterceptors()

export default http
